import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { buyer } = useContext(AuthContext);


  // Check if admin object exists and has valid role
  if (!buyer || buyer.role?.toLowerCase() !== "buyer") {
    return <Navigate to="/login" replace />;
  }

  return children;
};
